var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c("div", { staticClass: "modal-dialog modal-dialog-scrollable" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v("Switch Workspace for Your Project"),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button" },
                    on: { click: _vm.close },
                  },
                  [_vm._v("×")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                !_vm.initialized
                  ? _c("h4", [
                      _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                      _vm._v(" Loading..."),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.initialized
                  ? _c("div", [
                      _c("p", [
                        _vm._v("Move your project "),
                        _c("strong", [
                          _vm._v("'" + _vm._s(_vm.projectName) + "'"),
                        ]),
                        _vm._v(
                          " to a different workspace. Select the destination workspace from the list below."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newWorkspaceId,
                                expression: "newWorkspaceId",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.newWorkspaceId = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(_vm.workspaces, function (w) {
                            return _c(
                              "option",
                              { domProps: { value: w.WorkspaceId } },
                              [_vm._v(_vm._s(w.Name))]
                            )
                          }),
                          0
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      type: "button",
                      disabled: _vm.newWorkspaceId === _vm.workspaceId,
                    },
                    on: { click: _vm.handleMoveProject },
                  },
                  [_vm._v("Save")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.close },
                  },
                  [_vm._v("Close")]
                ),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }